import React from 'react';
import PropTypes from 'prop-types';

import { SpacerVertical, Typography } from '@klarna/bubble-ui';

export const DocumentsHeader = ({ title, subtitle }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        {title && <Typography textToken="text-style/text/labels/body/medium">{title}</Typography>}
        {subtitle && (
          <>
            <SpacerVertical spaceToken="space/150" />
            <Typography
              textToken="text-style/text/super-paragraphs/body/medium"
              colorToken="colors/text/neutral"
            >
              {subtitle}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

DocumentsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
